module.exports = __webpack_public_path__ + "51de1fc72b7fae5621b91d7e0f7d5a97.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/march-medal-s.png
// module id = 1874
// module chunks = 0